import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Card from 'UI/Card';

export const createAccountUrl = (account) => {
    return `//${account.slug}${process.env.COOKIE_URL}`;
};

export default class AccountList extends React.Component
{
    static propTypes = {
        accounts: PropTypes.object.isRequired,
    };

    render()
    {
        return <div className="w-full max-w-xs">
            <Card className='prose'>
                <h1>Accounts</h1>
                <nav>
                    {
                        _.map(this.props.accounts, account => (
                            <a key={account.id} href={createAccountUrl(account)} className="mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                                <span className="truncate">
                                    {account.name}
                                </span>
                            </a>
                        ))
                    }
                </nav>
                {
                    this.props.accounts.length < 1 &&
                        <div className='bg-gray-100 p-4 rounded'>
                            We could not find any accounts you are a member of.
                        </div>
                }
            </Card>
        </div>;
    }
}
